<div class="wizard-container" id="wizard-container">
  <div class="wizard-content" id="wizard-content">

    <!-- Loading overlay shown while submitting the wizard -->
    <div class="loading-overlay" *ngIf="isLoading" id="wizard-loading-overlay">
      <div class="loading-box" id="wizard-loading-box">
        <i class="fas fa-spinner fa-spin loading-icon" id="wizard-loading-icon" aria-hidden="true"></i>
        <div class="loading-text" id="wizard-loading-text">{{ translate('wizard.saving') }}</div>
      </div>
    </div>

    <!-- Indicador de progreso -->
    <div class="wizard-progress" id="wizard-progress">
      <div class="progress-steps" id="wizard-progress-steps">
        <div *ngFor="let step of steps; let i = index" class="progress-step"
          [ngClass]="{'active': i === currentStep, 'completed': i < currentStep}" [id]="'wizard-progress-step-' + i">
          <div class="step-number" [id]="'wizard-step-number-' + i">{{ i + 1 }}</div>
          <div class="step-label" [id]="'wizard-step-label-' + i">{{ translate(step.title) }}</div>
        </div>
      </div>
      <div class="progress-bar" id="wizard-progress-bar">
        <div class="progress-fill" [style.width.%]="(currentStep / (steps.length - 1)) * 100" id="wizard-progress-fill">
        </div>
      </div>
    </div>

    <!-- Contenido del paso actual -->
    <div class="wizard-step-content glass-effect" id="wizard-step-content">
      <app-wizard-profile-steps [view]="$any(this)"></app-wizard-profile-steps>
      <app-wizard-completion-step [view]="$any(this)"></app-wizard-completion-step>
    </div>

    <!-- Botones de navegación -->
    <div class="wizard-actions" id="wizard-actions">
      <button type="button" class="btn btn-outline-secondary" (click)="previousStep()" *ngIf="currentStep > 0"
        id="wizard-btn-previous">
        <i class="fas fa-arrow-left"></i> {{ translate('wizard.previous') }}
      </button>

      <button type="button" class="btn btn-primary" (click)="nextStep()" *ngIf="currentStep < steps.length - 1"
        id="wizard-btn-next">
        {{ translate('wizard.next') }} <i class="fas fa-arrow-right"></i>
      </button>

      <button type="button" class="btn btn-success" (click)="completeWizard()" *ngIf="currentStep === steps.length - 1"
        [disabled]="isLoading" id="wizard-btn-complete">
        <ng-container *ngIf="!isLoading">
          <i class="fas fa-check"></i> {{ translate('wizard.complete') }}
        </ng-container>
        <ng-container *ngIf="isLoading">
          <i class="fas fa-spinner fa-spin"></i> {{ translate('wizard.saving') }}
        </ng-container>
      </button>
    </div>
  </div>
</div>
